import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "./components/ui/sonner";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { AdminPage } from "./pages/Admin";
import api from "./services/api";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Update document title based on auth state
  useEffect(() => {
    if (isAuthenticated && user?.email) {
      document.title = `Netlen Webmail - ${user.email}`;
    } else {
      document.title = "Webmail - Netlen İnternet";
    }
  }, [isAuthenticated, user]);

  // Check for existing session on mount
  useEffect(() => {
    const checkAuth = async () => {
      const token = api.getToken();
      if (token) {
        try {
          const userData = await api.getCurrentUser();
          setUser(userData);
          setIsAuthenticated(true);
        } catch (err) {
          // Token invalid, clear it
          api.setToken(null);
        }
      }
      setIsLoading(false);
    };
    
    checkAuth();
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
  };

  const handleLogout = async () => {
    await api.logout();
    setUser(null);
    setIsAuthenticated(false);
  };

  // Show loading while checking auth
  if (isLoading) {
    return (
      <ThemeProvider>
        <div className="min-h-screen flex items-center justify-center bg-background">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider>
      {/* Bildirimler (toast): gönderim/hata/onay mesajları */}
      <Toaster position="top-right" richColors />
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Admin Panel - Ayrı route, auth gerektirmez (kendi auth'u var) */}
            <Route path="/admin/*" element={<AdminPage />} />
            
            <Route 
              path="/login" 
              element={
                isAuthenticated ? (
                  <Navigate to="/" replace />
                ) : (
                  <Login onLogin={handleLogin} />
                )
              } 
            />
            <Route 
              path="/*" 
              element={
                isAuthenticated ? (
                  <Dashboard user={user} onLogout={handleLogout} />
                ) : (
                  <Navigate to="/login" replace />
                )
              } 
            />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
